<script setup>

import {computed} from "vue";
import {useMain} from "@/stores/main";
import {useAppUpdate} from "@/composables/useAppUpdate";

const mainStore = useMain()
const { updateExists, refreshApp, refreshing } = useAppUpdate()

// Whether the status bar actually renders anything, so siblings can decide
// to show a separator next to it.
const hasContent = computed(() => updateExists.value || refreshing.value || !mainStore.isNetworkConnected)

defineExpose({ hasContent })

</script>

<template>
    <div v-if="updateExists" class="text-xs">
        <i class="mdi mdi-reload"/> Mise à jour disponible.<a href="" class="text-white underline hover font-bold text-right"
                                                            @click="refreshApp">Rafraichir</a></div>
    <div v-if="refreshing" class="">
        <i class="mdi mdi-reload mdi-spin text-sm"/> Mise à jour ...
    </div>
    <div v-if="! mainStore.isNetworkConnected">
        <i class="mdi mdi-lan-disconnect"/> Hors ligne
    </div>

</template>

<style scoped lang="scss">

</style>
